export const COLORS = {
  BLUE_1: '#4b5d7d',
  BLUE_2: '#e6e9ee',
  BLUE_3: '#6f7d97',
  BLUE_4: '#337ab7',
  BLUE_5: '#0e2756',
  BLUE_6: '#035792',
  BLUE_7: '#6289D9',
  BLUE_8: '#6280D9',
  BLUE_9: '#6289d97d',
  BLUE_10: '#80bdff',
  BLUE_11: '#2c66b9',
  BLUE_12: '#285ed1',
  BLUE_13: '#0d2755',
  BLUE_14: '#1880a5',
  BLUE_15: '#f4f7fb',
  BLUE_16: '#f3f4f7',
  BLUE_17: '#dfe8f5',
  BLUE_18: '#dbdfe6',
  BLUE_19: '#205094',
  BLUE_20: '#0561d9',
  BLUE_21: '#5dd7f6',
  WHITE: '#fff',
  WHITE_2: '#e7e7e7',
  WHITE_3: '#ddd',
  WHITE_4: '#f0f0f0',
  WHITE_5: '#f6f6f6',
  WHITE_6: '#dee2e6',
  WHITE_7: '#dfdfdf',
  WHITE_8: '#f4f4f4',
  WHITE_9: '#FFFFFFB2',
  BLACK: '#000000',
  BLACK_2: '#333',
  BLACK_3: '#414141',
  GREEN_1: '#c2efca',
  GREEN_2: '#79ac85',
  GREEN_3: '#70ba7d',
  GREEN_4: '#92b4a4',
  GREEN_5: '#36cb4f',
  GREEN_6: '#bceac4',
  GREEN_7: '#b1d9b1',
  GREEN_8: '#32936f',
  GREEN_9: '#236E53',
  GREEN_10: '#f5faf8',
  GREEN_11: '#f2f8fa',
  GREEN_12: '#e0efe9',
  GREEN_13: '#d9eaf1',
  GREEN_14: '#0076a0',
  GREEN_15: '#32936F1A',
  GREEN_16: '#32936F',
  YELLOW_1: '#ffdfb2',
  YELLOW_2: '#cb9f69',
  YELLOW_3: '#fff0b2',
  YELLOW_4: '#ceb96e',
  ORANGE_1: '#ff992c',
  ORANGE_2: '#f58a7d',
  ORANGE_3: '#FFA24E',
  ORANGE_4: '#FFA24E1A',
  ORANGE_5: '#e67e22',
  RED_1: '#ffc4c0',
  RED_2: '#b47571',
  RED_3: '#ff3b30',
  RED_4: '#ff0000',
  RED_5: '#fbbebb',
  RED_6: '#dc3545',
  RED_7: '#f25555',
  RED_8: 'rgba(242, 85, 85, 1)',
  RED_9: '#F255551A',
  GREY_1: '#c0c0c0',
  GREY_2: '#f7f7f7',
  GREY_3: '#747474',
  GREY_4: '#dbdfe5',
  GREY_5: '#414141',
  GREY_6: '#212529',
  GREY_7: '#a6a6a6',
  GREY_8: '#7c7c7c',
  GREY_9: '#dedede',
  GREY_10: '#f6f6f6',
  GREY_11: '#dbdbdb',
  GREY_12: '#f1f1f1',
  GREY_13: '#c8c5c5',
  GREY_14: '#707070',
  GREY_15: '#b5b5b5',
  GREY_16: '#343a40',
  GREY_17: '#403B4D',
  GREY_18: '#ced4da',
  GREY_19: '#cbcbcbad',
  GREY_20: '#cbcbcb',
  GREY_21: '#495057',
  GREY_22: '#ccc',
  GREY_23: '#949494',
  GREY_24: '#828282',
  GREY_25: '#E3E2E1',
  GREY_26: '#e9ecef',
  GREY_27: '#f1f3f5',
  GREY_28: '#0000000d',
  GREY_29: '#d0d0d0',
  GREY_30: '#d0d0d080',
  GREY_31: 'rgba(208, 208, 208, 1)',
  GREY_32: 'rgba(116, 116, 116, 1)',
  GREY_33: 'rgba(142, 142, 142, 1)',
  GREY_34: '#D9D9D9',
  GREY_35: '#8E8E8E',
  GREY_36: '#1E1E1E',
  GREY_37: '#2C2C2C',
  GREY_38: '#757575',
  GREY_39: '#b3b3b3',
  GREY_40: '#6b6b6b',
  GREY_41: '#dadada',
  GREY_42: '#e3e3e3',
  GREY_43: '#d0d0d0',
  PURPLE_1: '#852ef2',
};
